export const NAME_CONVENTIONS = [
  { id: "FYE", name: "Workflow type - Client Name - FYE date" },
  { id: "DUE_DATE", name: "Workflow type - Client Name - Due date" },
  { id: "YEAR", name: "Workflow type - Client Name - YEAR" },
  { id: "MONTH_YEAR", name: "Workflow type - Client Name - MONTH YEAR" },  
  { id: "TEMPLATE", name: "Template - Client Name - FYE date", excludeInEditMode: true },
  { id: "TEMPLATE_1", name: "Template - Client Name - Due date", excludeInEditMode: true },
  { id: "TEMPLATE_3", name: "Template - Client Name - YEAR", excludeInEditMode: true },
  { id: "TEMPLATE_4", name: "Template - Client Name - MONTH YEAR", excludeInEditMode: true },   
];
